export default __webpack_public_path__ + "static/media/Candle-2.8bb433af.svg";